import { cn } from "../lib/utils";

export interface PoweredByProps {
  /** The merged brand_config from the API response (anchor ⊕ active
   *  scope cascade). Reads ``powered_by_enabled`` and
   *  ``powered_by_text`` keys. Per the locked tenancy model
   *  (2026-04-21), the text refers to the IMMEDIATE parent partner -
   *  never further up the chain - and never uses the platform name. */
  readonly brand: Record<string, unknown> | undefined | null;
  readonly variant?: "footer" | "inline";
  readonly className?: string;
}

/** "Powered by &lt;parent partner&gt;" attribution. Renders only when
 *  the org/location admin has explicitly toggled it on through
 *  ``brand_config.powered_by_enabled``. The string itself is held in
 *  ``brand_config.powered_by_text`` so admins can localise / soften
 *  the wording (e.g. "An offering from Finterra"). */
export function PoweredBy({ brand, variant = "footer", className }: PoweredByProps) {
  if (!brand) return null;
  const enabled = brand["powered_by_enabled"];
  if (!enabled) return null;
  const text = brand["powered_by_text"];
  if (typeof text !== "string" || !text.trim()) return null;

  if (variant === "footer") {
    return (
      <div
        className={cn(
          "border-t border-line py-2.5 text-center text-[0.6875rem] tracking-wide text-faint",
          className,
        )}
      >
        {text}
      </div>
    );
  }

  return (
    <span className={cn("text-[0.6875rem] uppercase tracking-wide text-faint", className)}>
      {text}
    </span>
  );
}
